import { extendTheme } from "@mui/joy/styles";

export const joyUiTheme = extendTheme({
	components: {
		JoyTooltip: {
			defaultProps: {
				enterDelay: 500,
				arrow: true
			},
			styleOverrides: {
				root: {
					// Default has no width so never wraps.
					maxWidth: "20rem"
				}
			}
		}
	},
	colorSchemes: {
		light: {
			palette: {
				primary: {
					// Disabled colour was too light to read comfortably.
					plainDisabledColor: "var(--joy-palette-neutral-600)"
				}
			}
		}
	}
});
